import { render, staticRenderFns } from "./Calculators.vue?vue&type=template&id=0b1e2606&scoped=true&"
import script from "./Calculators.vue?vue&type=script&lang=js&"
export * from "./Calculators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e2606",
  null
  
)

export default component.exports